<div class="body row justify-content-md-center">
  <div class="col-sm-8" style="margin: auto;">
    <mat-card>
      <mat-card-title>
        <h1 class="text-center">Register</h1>
      </mat-card-title>
      <mat-card-title class="text-center">
        <img src="./assets/images/sf_logo.jpg" class="matero-branding-logo-expanded text-center" alt="logo" />
      </mat-card-title>
      <mat-card-content>
        <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>User Type</mat-label>
                <mat-select formControlName="userType" (selectionChange)="onChangeUserType()" disableOptionCentering>
                  <mat-option *ngFor="let userType of userTypeList" [value]="userType.code">
                    {{userType.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="submitted && f.userType.errors?.required" class="invalid-feedback">
                  User Type is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Industrial Vertical</mat-label>
                <mat-select formControlName="industryVertical" disableOptionCentering>
                  <mat-option *ngFor="let industryVertical of industryVerticalList" [value]="industryVertical.code">
                    {{industryVertical.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="submitted && f.industryVertical.errors?.required" class="invalid-feedback">
                  Industrial Vertical is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Type Of Agency</mat-label>
                <mat-select formControlName="typeOfAgency" disableOptionCentering>
                  <mat-option *ngFor="let typeOfAgency of typeOfAgencyList" [value]="typeOfAgency.code">
                    {{typeOfAgency.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="submitted && f.typeOfAgency.errors?.required" class="invalid-feedback">
                  Type Of Agency is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="firstName" placeholder="First Name" type="text" maxlength="25">
                <mat-error *ngIf="submitted && f.firstName.errors?.required" class="invalid-feedback">
                  First name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastName" placeholder="Last Name" type="text" maxlength="25">
                <mat-error *ngIf="submitted && f.lastName.errors?.required" class="invalid-feedback">
                  Last name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Company</mat-label>
                <input matInput formControlName="company" placeholder="Company" type="text" maxlength="20">
                <mat-error *ngIf="submitted && f.company.errors?.required" class="invalid-feedback">
                  Company name is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" placeholder="Password" type="password" maxlength="10">
                <mat-error *ngIf="submitted && f.password.errors?.required" class="invalid-feedback">
                  Password is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-6">
              <mat-form-field appearance="outline">
                <mat-label>Confirm Password</mat-label>
                <input matInput formControlName="confirmPassword" placeholder="Confirm Password" type="password"
                  maxlength="10">
                <mat-error *ngIf="submitted && f.confirmPassword.errors?.required" class="invalid-feedback">
                  Confirm Password is required
                </mat-error>
                <mat-error class="invalid-feedback"
                  *ngIf="(f.confirmPassword.errors?.mustMatch && (registrationForm.touched || registrationForm.dirty))">
                  Password and confirm password doesn't match.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <mat-form-field fxFlex="100" fxFlex.lt-md="100" fxFlex.lt-sm="100" appearance="outline">
                <mat-label>Address</mat-label>
                <input matInput formControlName="address" placeholder="Address" type="text" maxlength="50">
                <mat-error *ngIf="submitted && f.address.errors?.required" class="invalid-feedback">
                  Address is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>Country</mat-label>
                <mat-select formControlName="country" (selectionChange)="onChangeCountry($event)" disableOptionCentering>
                  <mat-option>--None--</mat-option>
                  <mat-option *ngFor="let country of countryList" [value]="country.id">
                    {{country.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="submitted && f.country.errors?.required" class="invalid-feedback">
                  Country is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>State/Province</mat-label>
                <mat-select formControlName="state" (selectionChange)="onChangeState($event)" disableOptionCentering>
                  <mat-option>--None--</mat-option>
                  <mat-option *ngFor="let state of stateList" [value]="state.id">
                    {{state.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="submitted && f.state.errors?.required" class="invalid-feedback">
                  State/Province is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <mat-select formControlName="city" disableOptionCentering>
                  <mat-option>--None--</mat-option>
                  <mat-option *ngFor="let city of cityList" [value]="city.id">
                    {{city.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="submitted && f.city.errors?.required" class="invalid-feedback">
                  City is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100" appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" oninput="this.value = this.value.toLowerCase()"
                  placeholder="Email ID" type="email" maxlength="50">
                <mat-error *ngIf="submitted && f.email.errors?.required" class="invalid-feedback">
                  Email ID is required
                </mat-error>
                <mat-error *ngIf="submitted && f.email.errors?.pattern" class="invalid-feedback">
                  Please enter valid Email ID
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100" appearance="outline">
                <mat-label>Country Code</mat-label>
                <input matInput formControlName="countryCode" placeholder="Country Code" type="text">
                <mat-error *ngIf="submitted && f.countryCode.errors?.required" class="invalid-feedback">
                  Country Code is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field fxFlex="33" fxFlex.lt-md="50" fxFlex.lt-sm="100" appearance="outline">
                <mat-label>Telephone</mat-label>
                <input matInput formControlName="telephone" OnlyNumber placeholder="Telephone" type="tel"
                  maxlength="15">
                <mat-error *ngIf="submitted && f.telephone.errors?.required" class="invalid-feedback">
                  Telephone is required
                </mat-error>
                <mat-error class="invalid-feedback" *ngIf="submitted && (f.telephone.errors?.minlength)">
                  Telephone must be greater than 10 digit
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <mat-checkbox formControlName="termsCondition" (change)="onClickTermCondition()">Terms & Conditions
              </mat-checkbox>
            </div>
          </div>
          <mat-card-actions align="center">
            <button mat-flat-button routerLinkActive="active" [disabled]="!f.termsCondition.value" type="submit"
              color="primary">Sign Up
            </button>
            <!-- <button mat-flat-button class="m-2" type="button" color="warn" (click)="onClickBack()">Back</button> -->
          </mat-card-actions>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>